import moment from 'moment'

export const formatDate = ({ date, format = 'DD [de] MMMM [de] YYYY', capitalizeMonth = false }) => {
  const momentDate = moment(date).locale('pt-br')
  if (capitalizeMonth) {
    const month = momentDate.format('MMMM')
    const capitalizedMonth = capitalize(month)
    return momentDate.format(format).replace(month, capitalizedMonth)
  }
  return momentDate.format(format)
}

export const formatMoney = (value = 0) => {
  return Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(value).replace(/\s/g, '')
}

export const capitalize = (value) => {
  return value.charAt(0).toUpperCase() + value.slice(1)
}

export const formatCampaign = {
  PERCENTAGE: (value) => `${value}%`,
  FIXED: (value) => formatMoney(value)
}

export const formatCpf = (cpf) => {
  if (cpf) {
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
  }
}

export const truncateText = (text, maxLength) => text.length <= maxLength ? text : text.substring(0, maxLength) + '...'

export const formatListToString = (list) => {
  const lastItem = list[list.length - 1]
  const otherItems = list.slice(0, -1)
  return otherItems?.join(', ') + (otherItems?.length ? ' e ' : '') + lastItem
}

export const formatPhone = (phone) => {
  if (phone) {
    return phone.replace(/^(\d{2})(\d{5})(\d{4}).*/, '($1) $2-$3')
  }
}

export const formatProfessionalName = (name) => {
  return name.split(/CNPJ|[A-Za-z0-9]{2}\.[A-Za-z0-9]{3}\.[A-Za-z0-9]{3}\/[A-Za-z0-9]{4}-[0-9]{2}/)[0].trim()
}
